
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error' | null

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API_BASE}/settings/newsletter/subscribe`, { email });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <footer className="fixed bottom-0 left-0 w-screen h-auto md:h-[58vh] pb-4 md:pb-0 bg-black text-white flex flex-col justify-end px-4 py-4 md:py-6 z-0 overflow-hidden font-bdogrotesk">

      <div className="relative z-10 max-w-full px-2 md:px-6 flex flex-col md:flex-row md:items-start gap-4 md:gap-8">

        {/* Col 1: Heading */}
        <div className="md:w-1/3">
          <h2 className="text-[3rem] md:text-[5rem] lg:text-[6.5rem] leading-[1] font-semibold">Bye,<br />Baddie</h2>
          <p className="mt-1 md:mt-3 text-2xl md:text-4xl">Come Back Soon!</p>
        </div>

        {/* Col 2: Links – starts at ~middle of screen, two sub-columns */}
        <div className="md:w-1/3 flex gap-8 md:gap-12">
          {/* Left sub-column */}
          <ul className="space-y-1 md:space-y-2 text-sm md:text-base">
            <li><a href="https://www.instagram.com/nufab.studio?igsh=dTZyM3Frem1hb3Y5&utm_source=qr" target="_blank" rel="noreferrer" className="hover:opacity-80">Instagram</a></li>
            <li><a href="https://in.pinterest.com/nufabinfo/?actingBusinessId=1078541948169783210" className="hover:opacity-80">Pinterest</a></li>
            <li className="pt-4 md:pt-6"><Link to="/store" className="hover:opacity-80">Store</Link></li>
            <li><Link to="/orders" className="hover:opacity-80">Your Orders</Link></li>
            <li><Link to="/blogs" className="hover:opacity-80">Blog</Link></li>
            <li><Link to="/about" className="hover:opacity-80">About Us</Link></li>
            <li><Link to="/photo-booth" className="hover:opacity-80">Photo Album</Link></li>
          </ul>

          {/* Right sub-column */}
          <ul className="space-y-1 md:space-y-2 text-sm md:text-base">
            <li><Link to="/faqs" className="hover:opacity-80">FAQs</Link></li>
            <li><Link to="/contact" className="hover:opacity-80">Contact Us</Link></li>
            <li className="pt-4 md:pt-6"><Link to="/terms-of-service" className="hover:opacity-80">Terms of Service</Link></li>
            <li><Link to="/privacy-policy" className="hover:opacity-80">Privacy Policy</Link></li>
            <li><Link to="/return-policy" className="hover:opacity-80">Return &amp;<br className="md:hidden" /> Cancellation</Link></li>
            <li><Link to="/exchange-policy" className="hover:opacity-80">Delivery Policy</Link></li>
          </ul>
        </div>

        {/* Col 3: Newsletter */}
        <div className="w-full md:w-2/5 lg:w-5/12 md:ml-auto">
          <p className="mb-2 text-sm font-bdogrotesk">Sign up to receive occasional, thoughtfully sent newsletters from our studio</p>
          {status === 'success' ? (
            <p className="text-white font-bdogrotesk text-sm py-2">You're in. Welcome to the everyday.</p>
          ) : (
            <form onSubmit={handleSubscribe}>
              <div className="flex items-center gap-2 w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setStatus(null); }}
                  placeholder="Email"
                  className="flex-1 bg-black border border-white rounded-none px-3 py-2 text-sm placeholder:text-white/60 focus:outline-none"
                />
                <button type="submit" className="bg-white text-black px-4 py-2 text-sm whitespace-nowrap">Subscribe</button>
              </div>
              <p className="mt-1 text-xs text-white/60">By subscribing you agree to our <Link to="/terms-of-service" className="underline hover:opacity-80">Terms of Service</Link>.</p>
              {status === 'error' && <p className="text-red-400 text-xs mt-1">Something went wrong. Please try again.</p>}
            </form>
          )}
        </div>
      </div>

      <div className="relative z-10 mt-3">
        <div className="max-w-full px-6 py-1 flex justify-end">
          <div className="text-xs text-white/50 font-bdogrotesk">Copyright © {new Date().getFullYear()} Green Agritech. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
